require('../../modules/es6.array.some');
module.exports = require('../../modules/_core').Array.some;



//////////////////
// WEBPACK FOOTER
// /home/abuild/rpmbuild/BUILD/Portus-v2.3/~/core-js/fn/array/some.js
// module id = 268
// module chunks = 0